import { render, staticRenderFns } from "./GroupTrainer.vue?vue&type=template&id=8dea6468&scoped=true&"
import script from "./GroupTrainer.vue?vue&type=script&lang=js&"
export * from "./GroupTrainer.vue?vue&type=script&lang=js&"
import style0 from "./GroupTrainer.vue?vue&type=style&index=0&id=8dea6468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dea6468",
  null
  
)

export default component.exports